import { formattedDateTime } from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import { TableCell } from "@circle-react-uikit/Table";
import type { CellVariant } from "@circle-react-uikit/Table/TableCell";
import { Typography } from "@circle-react-uikit/Typography";
import type { Member } from "../types";

interface LastActiveColumnProps {
  cellVariant: CellVariant;
  hideColumn: boolean;
  member: Member;
}

export const LastActiveColumn = ({
  member,
  cellVariant,
  hideColumn,
}: LastActiveColumnProps) => {
  if (hideColumn) {
    return null;
  }

  const lastSeenAt = member?.lastActive
    ? formattedDateTime({
        dateTime: new Date(member.lastActive),
        format: "long_date",
      })
    : "";

  return (
    <TableCell variant={cellVariant} className="">
      <Typography.LabelSm color="text-selector-active">
        {lastSeenAt}
      </Typography.LabelSm>
    </TableCell>
  );
};
